import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createUnit,
  deleteUnit,
  getUnit,
  getUnitByMitra,
  updateUnit,
  bulkCreateUnit,
} from "libs/api/unit";

// Unit Thunk
export const getUnitThunk = createAsyncThunk(
  "unit/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getUnit(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Bulk Create Unit Thunk
export const bulkCreateUnitThunk = createAsyncThunk(
  "unit/bulk-create",
  async ({
    units,
    accessToken,
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await bulkCreateUnit(units, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Unit Thunk
export const getUnitByMitraThunk = createAsyncThunk(
  "unit-mitra/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getUnitByMitra(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Create Unit Thunk
export const createUnitThunk = createAsyncThunk(
  "unit/create",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createUnit(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Update Unit Thunk
export const updateUnitThunk = createAsyncThunk(
  "unit/update",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateUnit(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// Delete Role Thunk
export const deleteUnitThunk = createAsyncThunk(
  "unit/delete",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteUnit(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);
